import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/hr/me/performance')({
  component: MyPerformancePage,
})

function MyPerformancePage() {
  const { data, isLoading } = useQuery(orpc.hr.me.listOwnPerformance.queryOptions({ input: {} }))
  const rows = (data ?? []) as Array<{
    id: number
    reviewCycle: string | null
    periodStart: string | null
    periodEnd: string | null
    status: string | null
  }>

  return (
    <Card>
      <CardContent className="p-0">
        {isLoading ? (
          <div className="p-6 text-muted-foreground">Loading...</div>
        ) : rows.length === 0 ? (
          <div className="p-6 text-muted-foreground">No performance reviews yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Review cycle</TableHead>
                <TableHead>Period</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => {
                const period =
                  r.periodStart && r.periodEnd
                    ? `${new Date(r.periodStart).toLocaleDateString()} – ${new Date(
                        r.periodEnd,
                      ).toLocaleDateString()}`
                    : '-'
                return (
                  <TableRow key={r.id}>
                    <TableCell>{r.reviewCycle ?? '-'}</TableCell>
                    <TableCell>{period}</TableCell>
                    <TableCell>{r.status ?? '-'}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
